import MessageLogger from './utils/messageLogger';

function hasParam(val) {
	let result = false;
	let items = location.search;
	items = items.substr(1).split('&');
	for (let i = 0; i < items.length; i++) {
		if (items[ i ].indexOf(val) >= 0) {
			result = true;
			break;
		}
	}
	return result;
}

const showDebug = hasParam('debug');
let debugContainer = null;
let logContainer = null;

if (showDebug) {
	debugContainer = $('<div style="' +
		'position: fixed; ' +
		'z-index: 999999; ' +
		'left: 0; bottom: 0; ' +
		'width: 70%; ' +
		'height: 300px; ' +
		'background: #044; ' +
		'color: #fff; ' +
		'font-size: 12px; ' +
		'padding: 10px; ' +
		'font-family: monospace;' +
		'"></div>');
	$('body').append(debugContainer);

	// eslint-disable-next-line max-len
	logContainer = $('<div style="overflow: auto; width: 100%; height: 270px; word-break: break-all; line-height: 1.4;"></div>');
	debugContainer.append(logContainer);
}

// eslint-disable-next-line no-magic-numbers
const logger = new MessageLogger(100, 20);

window.log = function() {
	if (showDebug && logContainer) {
		// eslint-disable-next-line no-console
		console.log(arguments);
		let text = '';
		text += '<b>[' + (new Date()).toISOString() + ']</b> ';
		for (const a in arguments) {
			if (arguments.hasOwnProperty(a)) {
				if (JSON && JSON.stringify && typeof arguments[ a ] === 'object') {
					text += JSON.stringify(arguments[ a ]) + ', ';
				} else {
					text += arguments[ a ] + ', ';
				}
			}
		}
		logContainer.html('<div>' + text + '</div>' + logContainer.html());
	}
	try {
		logger.logMessage(`[${(new Date()).toISOString()}] ${Array.from(arguments).map(a => 
			JSON && JSON.stringify && typeof a === 'object' ? JSON.stringify(a) : a
		).join(', ') }`);
	} catch (ex) {
		Screen.logErrorToSentry(ex);
	}
	
};

export function getLogDump() {
	return logger.dump;
}

window.plecto_logger = logger;
